import statistic from './statistic'

export default {
  settings: {
    hasGamerCondition: true
  },
  actionTypes: {
    score: [
      'PT1',
      'PT2',
      'ADJUST_POINTS'
    ],
    foul: ['FOUL']
  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component'
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    gamerCondition: {
      home: {
        eventCode: '',
        title: '...'
      },
      away: {
        eventCode: '',
        title: '...'
      }
    },
    fouls: {
      home: 0,
      away: 0
    },
    score: {
      home: 0,
      away: 0
    }
  }
}
